import { colors } from '../../style-guide/colors'
export const multiOptionsSelectPickerTheme = {
   light: {
      closeIconFillColor: colors['base-black']
   },
   dark: {}
}
